import { useState } from "react";
import { Transition } from "@headlessui/react";
import { motion } from "framer-motion";
import { Image, MoveRight } from "lucide-react";

export default function Card({
    title,
    ingredients,
    price,
    image,
    quantity,
    alcoholPercentage,
    type,
    isAvailable,
    showDetailPage,
    isNew,
    onClick,
}) {
    const [loaded, setLoaded] = useState(false);

    return (
        <Transition
            appear
            show={true}
            enter="transition ease-out duration-300"
            enterFrom="opacity-0 translate-y-4"
            enterTo="opacity-100 translate-y-0"
        >
            <motion.div
                whileTap={{ scale: 0.98 }}
                onClick={() => showDetailPage && onClick?.()}
                className={`w-full px-4 py-3 ${showDetailPage ? "cursor-pointer" : "cursor-default"}`}
            >
                <div className={`relative group bg-surface border border-accent rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 px-6 py-6 flex flex-col items-center text-center space-y-4 ${showDetailPage ? "ring-1 ring-primary/40 hover:ring-primary/80" : ""}`}>

                    {isNew && (
                        <div className="absolute top-4 right-4 bg-primary text-secondary text-[10px] font-bold uppercase px-2 py-[2px] rounded-md shadow-md z-10 tracking-wider">
                            NEW
                        </div>
                    )}

                    {/* 🔘 Immagine */}
                    <div className="relative w-24 h-24 rounded-full border-2 border-primary bg-background shadow-[0_0_20px_rgba(233,69,69,0.15)] overflow-hidden group-hover:scale-105 transition-transform duration-300">

                        {/* Skeleton */}
                        {!loaded && (
                            <div className="absolute inset-0 rounded-full bg-accent/40 animate-pulse" />
                        )}

                        {image ? (
                            <img
                                src={image}
                                alt={title}
                                crossOrigin="anonymous"
                                onLoad={() => setLoaded(true)}
                                className={`w-full h-full object-cover rounded-full transition-opacity duration-300 ${loaded ? "opacity-100" : "opacity-0"
                                    }`}
                            />
                        ) : (
                            <div className="w-full h-full flex items-center justify-center text-muted bg-background rounded-full">
                                <Image className="w-6 h-6" />
                            </div>
                        )}

                        {!isAvailable && (
                            <div className="absolute inset-0 bg-black/40 z-10 flex items-center justify-center">
                                <div className="w-28 h-1 bg-primary rotate-45" />
                            </div>
                        )}
                    </div>

                    {/* 📋 Titolo */}
                    <h3 className="text-secondary font-semibold text-lg leading-tight tracking-tight">
                        {title}
                    </h3>

                    {/* 🍕 Ingredienti */}
                    {ingredients && (
                        <p className="text-sm text-muted leading-snug max-w-xs">
                            {ingredients}
                        </p>
                    )}

                    {/* 🥤 Info drink */}
                    {type === "drink" && (
                        <div className="text-muted text-xs sm:text-sm flex gap-4">
                            {quantity && <span>{quantity}</span>}
                            {alcoholPercentage && <span>Vol. {alcoholPercentage}</span>}
                        </div>
                    )}

                    {/* 💶 Prezzo */}
                    <div>
                        <div
                            className={`px-3 py-1 rounded-full text-sm font-bold shadow-inner border border-accent min-w-[60px] text-center ${isAvailable
                                ? "bg-secondary text-background"
                                : "bg-accent text-muted"
                                }`}
                        >
                            {isAvailable ? price : "Non disponibile al momento"}
                        </div>
                    </div>

                    {/* 🔗 Icona cliccabile per dettaglio */}
                    {showDetailPage && (
                        <div className="absolute bottom-[2px] right-[2px] translate-x-1 translate-y-1 p-2 bg-primary text-background rounded-tl-[26px] rounded-br-[24px] opacity-80 group-hover:opacity-100 transition-opacity duration-200">
                            <MoveRight className="w-4 h-4" />
                        </div>
                    )}
                </div>
            </motion.div>
        </Transition>
    );
}